import { JsonProvider } from 'leaflet-geosearch'

class CoordinatesProvider extends JsonProvider {
  search({ query, type }) {
    let data = this.parse(query)

    if (data) {
      return [{
        x: parseFloat(data[1]),
        y: parseFloat(data[0]),
        label: `${data[0]}, ${data[1]}`,
        visibleLabel: `Lat: ${data[0]} - Lng: ${data[1]}`,
        bounds: data
      }]
    } else {
      return []
    }
  }

  parse(query) {
    let data = query.split(',')

    if (!Array.isArray(data) || data.length !== 2) {
      data = query.split('\t')
    }
    if (!Array.isArray(data) || data.length !== 2) {
      data = query.split(';')
    }
    if (!Array.isArray(data) || data.length !== 2) {
      data = query.split('|')
    }
    if (data.length === 2) {
      return [parseFloat(data[0].replace(',', '.').trim()), parseFloat(data[1].replace(',', '.').trim())]
    } else return false
  }
}

export default CoordinatesProvider
